import React, { memo, useEffect, useRef, useState } from 'react'
import PaymentModalStyle from './PaymentModalStyle'

import api, { customFuncsApi, cashbackApi } from '../../../api'
import Modal from 'react-modal'
import { get } from 'lodash'
import Button from '../../Button'
import { ErrorModal, RefundModal, SuccessModal } from '../index'
import { useSelector } from 'react-redux'
import { roundCurrency } from '../../../utils'
import ConfirmModal from '../../ComfirmModal'
import { message, Popconfirm } from 'antd'
import { formatMoneyNumber } from '../../../lib/FormatMoney'
import numberWithSpaces from '../../../helpers/numberWithSpaces'
import Spinner from '../../Spinner/index'
import { removeSpaces } from '../../../helpers/formatNumber'
import { CASHBACK_COMPANY_DB } from '../../../config'

const CASHBACK_ERROR_MESSAGES = {
	InvalidPhoneNumber: "Telefon raqami noto'g'ri",
	CustomerNotFound: 'Mijoz topilmadi',
	NoCashbackAvailable: "Bu mijozda yechish uchun cashback yo'q",
	SapUnavailable: "SAP tizimi javob bermayapti. Birozdan so'ng urinib ko'ring.",
}

const getCashbackErrorMessage = (err) =>
	CASHBACK_ERROR_MESSAGES[get(err, 'response.data.code')] ||
	'Kutilmagan xatolik yuz berdi'

const customStyles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',
		width: '700px',
		maxHeight: '90vh',
		overflowY: 'auto',
	},
}

const MoneyInput = ({
	placeholder,
	form,
	setForm,
	editableKey,
	className,
	...props
}) => {
	return (
		<input
			className={
				'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full ' + className
			}
			{...props}
			placeholder={placeholder}
			onChange={(e) => {
				const currentValue = e.target.value.replace(/ /g, '')

				if (/^[0-9]*[.,]?[0-9]*$/.test(currentValue)) {
					const normalizedValue = currentValue.replace(',', '.')

					setForm((prevValue) => ({
						...prevValue,
						[editableKey]: normalizedValue,
					}))
				}
			}}
			value={
				form[editableKey] != null ? formatMoneyNumber(form[editableKey]) : ''
			}
		/>
	)
}

const PaymentModal = ({
	getRef = () => {},
	onConfirm = () => {},
	onClose = () => {},
	loading,
	currencyRate,
	refundShow = true,
	debt = '',
	isPayOnlyDocTotal = false,
	docTotal = 0,
	cardCode = null,
	docEntry = null,
	phone = null,
	onCashbackRedeemed = () => {},
}) => {
	const { getMe, roleAccess } = useSelector((state) => state.main)

	const employeeID = getMe?.EmployeeID
	const isFilterByExternalCode = roleAccess?.U_MenuCardFilterByExtCode === 'Y'

	const currentDate = new Date()
	const successModalRef = useRef()
	const errorRef = useRef()
	const year = currentDate.getFullYear()
	const month = String(currentDate.getMonth() + 1).padStart(2, '0') // Months are zero-based, so add 1 and pad with '0' if needed
	const day = String(currentDate.getDate()).padStart(2, '0')
	const formattedDate = `${year}-${month}-${day}`
	const refundRef = useRef()
	const [isOpenModal, setIsOpenModal] = useState(false)
	const initDate = {
		dateC: formattedDate,
		amountUzs: null,
		amountUsd: null,
		payme: null,
		numberCard: null,
		terminal: null,
		dollar: currencyRate,
		UsdCard: null,
		UzsCard: null,
	}
	const [form, setForm] = useState({ ...initDate })
	const [isRefund, setIsRefund] = useState(false)
	const [showModal, setShowModal] = useState(false)
	const [confirmationMessage, setConfirmationMessage] = useState('')

	const [cashbackRedeeming, setCashbackRedeeming] = useState(false)
	const [cashbackBalance, setCashbackBalance] = useState(null)
	const [cashbackBalanceLoading, setCashbackBalanceLoading] = useState(false)

	const getClientPhone = () =>
		phone
			?.split(',')
			.map((p) => p.trim())
			.filter(Boolean)[0] || null

	const normalizePhone = (p) => (p || '').replace(/\D/g, '').slice(-9)

	const totalPayment = roundCurrency(
		(+form.amountUsd || 0) +
			(+form.amountUzs || 0) / (form.dollar || 1) +
			(+form.payme || 0) / (form.dollar || 1) +
			(+form.terminal || 0) / (form.dollar || 1),
	)

	useEffect(() => {
		const ref = {
			open: () => {
				setIsOpenModal(true)
			},
			close: () => setIsOpenModal(false),
		}
		getRef(ref)
	}, [])

	const handleShowModal = () => {
		console.log('handleShowModal', isPayOnlyDocTotal, +totalPayment, docTotal)
		if (isPayOnlyDocTotal && +totalPayment > docTotal) {
			errorRef.current?.open('Сумма платежа превышает  сумму покупки')
			console.log('handleShowModal')
			return
		}
		if (
			+form.amountUsd > 0 &&
			!usdCashs.some((cash) => cash?.Code == form.UsdCard)
		) {
			errorRef.current?.open('USD касса не найдена')
			return
		}
		if (
			form.amountUzs > 0 &&
			!accountsDataUZS.some((cash) => cash?.Code == form.UzsCard)
		) {
			errorRef.current?.open('UZS касса не найдена')
			return
		}
		if (
			form.payme > 0 &&
			!uzsCardsData.some((cash) => cash?.Code == form.numberCard)
		) {
			errorRef.current?.open('Карта Payme | Click касса не найдена')
			return
		}
		const debtWithPercent = Math.round((debt / 100) * 105)
		// const total = parseFloat(
		// 	roundCurrency(
		// 		(+form.amountUsd || 0) +
		// 			(+form.amountUzs || 0) / (form.dollar || 1) +
		// 			(+form.payme || 0) / (form.dollar || 1) +
		// 			(+form.terminal || 0) / (form.dollar || 1),
		// 	),
		// )

		console.log(form)

		if (debt !== '' && debt !== null && debtWithPercent < totalPayment) {
			errorRef.current?.open('Сумма к оплате превышает сумму задолжность')
			return
		}

		setConfirmationMessage([
			{
				name: 'Дата:',
				value: form.dateC,
			},
			{
				name: 'Курс:',
				value: form.dollar,
			},
			{
				name: 'USD:',
				value: !!form.amountUsd ? form.amountUsd : 0,
			},
			{
				name: 'usd касса:',
				value: form.UsdCard,
			},
			{
				name: 'Наличные UZS',
				value: !!form.amountUzs ? form.amountUzs : 0,
			},
			{
				name: 'uzs касса:',
				value: form.UzsCard,
			},
			{
				name: 'PayMe:',
				value: !!form.payme ? form.payme : 0,
			},
			{
				name: 'Номер PayMe кассы:',
				value: form.numberCard,
			},
			{
				name: 'Терминал:',
				value: !!form.terminal ? form.terminal : 0,
			},
			{
				name: 'Номер терминал карты:',
				value: getMe.U_TerminalAccount,
			},
		])
		setShowModal(true)
	}

	const handleRefund = ({
		DocDate,
		Type,
		CashSumUzs,
		CashSumUsd,
		numberCard1,
		numberCard2,
	}) => {
		setIsRefund(true)
		customFuncsApi
			.post(`addMoneyChange`, {
				DocDate: DocDate,
				Type: Type,
				CashSumUzs: +removeSpaces(CashSumUzs),
				CashSumUsd: +removeSpaces(CashSumUsd),
				[Type === 'UsdToUzs' ? 'CashUsdAccount' : 'CashUzsAccount']:
					numberCard1,
				[Type === 'UsdToUzs' ? 'CashUzsAccount' : 'CashUsdAccount']:
					numberCard2,
			})
			.then(() => {
				refundRef.current?.clear()
				refundRef.current?.close()
				successModalRef.current?.open('Платеж успешно произведен!')
			})
			.catch((err) => {
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
			})
			.finally(() => {
				setIsRefund(false)
			})
	}

	const fetchCashbackBalance = async () => {
		const clientPhone = getClientPhone()
		if (!clientPhone) {
			setCashbackBalance(null)
			return
		}
		setCashbackBalanceLoading(true)
		try {
			const res = await cashbackApi.get('cashback/balance', {
				params: { phone: clientPhone, page: 1, pageSize: 50 },
			})
			const item = get(res, 'data.items', []).find(
				(i) => normalizePhone(i.phone) === normalizePhone(clientPhone),
			)
			setCashbackBalance(item || { available: 0, currency: '' })
		} catch (err) {
			setCashbackBalance(null)
		} finally {
			setCashbackBalanceLoading(false)
		}
	}

	useEffect(() => {
		if (isOpenModal) {
			fetchCashbackBalance()
		} else {
			setCashbackBalance(null)
		}
	}, [isOpenModal, phone])

	const hasCashbackAvailable = +get(cashbackBalance, 'available', 0) > 0

	const handleRedeemCashback = async () => {
		if (cashbackRedeeming) {
			return
		}
		if (!cardCode) {
			errorRef.current?.open('Mijoz aniqlanmadi')
			return
		}
		const clientPhone = getClientPhone()
		if (!clientPhone) {
			errorRef.current?.open('Mijozning telefon raqami topilmadi')
			return
		}
		if (!hasCashbackAvailable) {
			errorRef.current?.open(CASHBACK_ERROR_MESSAGES.NoCashbackAvailable)
			return
		}
		setCashbackRedeeming(true)
		try {
			const res = await cashbackApi.post('cashback/redeem', {
				phone: clientPhone,
				companyDb: CASHBACK_COMPANY_DB,
				docEntry,
			})
			successModalRef.current?.open(
				`Cashback muvaffaqiyatli yechildi: ${Number(res.data.redeemedAmount).toFixed(2)} ${res.data.currency}. Provodka: ${res.data.journalEntryNumber}`,
			)
			setCashbackBalance(null)
			onCashbackRedeemed()
		} catch (err) {
			errorRef.current?.open(getCashbackErrorMessage(err))
		} finally {
			setCashbackRedeeming(false)
		}
	}

	const [uzsCardsData, setUzsCardsData] = useState([])
	const [usdCardsData, setUsdCardsData] = useState([])
	const [accountsDataUSD, setAccountsDataUSD] = useState([])
	const [accountsDataUZS, setAccountsDataUZS] = useState([])

	useEffect(() => {
		api
			.get(
				`ChartOfAccounts?$filter=U_User eq ${employeeID} or U_User2 eq ${employeeID}&$select=Code,Name,AcctCurrency,U_User,U_User2`,
				{
					headers: {
						Prefer: 'odata.maxpagesize=10000',
					},
				},
			)
			.then((res) => {
				const resData = JSON.parse(res.data).value
				const uzsCash = resData.filter((item) => item.AcctCurrency === 'UZS')
				const usdCash = resData.filter((item) => item.AcctCurrency === 'USD')
				setAccountsDataUSD(usdCash)
				setAccountsDataUZS(uzsCash)
				setForm((prev) => ({
					...prev,
					UzsCard: uzsCash.length ? uzsCash[0].Code : '',
					UsdCard: usdCash.length ? usdCash[0].Code : '',
				}))
			})
			.catch((err) => {
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
			})
	}, [])

	useEffect(() => {
		api
			.get(
				`ChartOfAccounts?$filter=startswith(Code, '57') and ${!isFilterByExternalCode ? 'ExternalCode ne null' : `contains(ExternalCode, '${getMe.U_AccountCode}')`}&$select=Code,Name,AcctCurrency`,
				{
					headers: {
						Prefer: 'odata.maxpagesize=10000',
					},
				},
			)
			.then((res) => {
				const resData = JSON.parse(res.data).value
				const uzsCash = resData.filter((item) => item.AcctCurrency === 'UZS')
				const usdCash = resData.filter((item) => item.AcctCurrency === 'USD')
				setUzsCardsData(uzsCash)
				setUsdCardsData(usdCash)
			})
			.catch((err) => {
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
			})
	}, [])

	const handleCancel = () => {
		setShowModal(false)
	}

	const handleBlur = () => {
		const current = parseFloat(form.dollar)
		if (isNaN(current)) {
			return
		}

		if (!currencyRate) {
			message.error('Курс доллара не найден')
		}

		const min = currencyRate - 200
		const max = currencyRate + 200

		if (current >= min && current <= max) {
			// Valid range, update previousValue
			setForm((prev) => ({
				...prev,
				dollar: current.toString(),
			}))
		} else {
			// Out of range, revert
			message.error(`Курс доллара должен быть в пределах ${min} - ${max}`)
			setForm((prev) => ({
				...prev,
				dollar: currencyRate.toString(),
			}))
		}
	}

	const usdCashs = [...accountsDataUSD, ...usdCardsData]

	return (
		<Modal
			isOpen={isOpenModal}
			onRequestClose={() => {
				setIsOpenModal(false)
				setForm({ ...initDate })
				setShowModal(false)
			}}
			style={customStyles}
			contentLabel="Example Modal"
			ariaHideApp={false}
		>
			<PaymentModalStyle>
				<div className="w-full">
					<h2 className="text-lg font-bold text-zinc-900 text-center mb-6">
						{'Добавить платеж'}
					</h2>
					<div className="grid grid-cols-1 gap-4">
						<div className="flex flex-col md:flex-row gap-4">
							<input
								className={
									'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full'
								}
								type={'date'}
								placeholder={'Дата'}
								value={form.dateC}
								disabled={true}
								onChange={(v) =>
									setForm((prevValue) => ({
										...prevValue,
										dateC: v.target.value,
									}))
								}
							/>
							<input
								className={
									'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full'
								}
								placeholder={'Курс'}
								value={form.dollar}
								onChange={(v) =>
									setForm((prevValue) => ({
										...prevValue,
										dollar: v.target.value,
									}))
								}
								onBlur={handleBlur}
							/>
						</div>
						<div className={'flex flex-col gap-2'}>
							<div className={'flex flex-col md:flex-row gap-4'}>
								<MoneyInput
									placeholder="USD"
									editableKey={'amountUsd'}
									form={form}
									setForm={setForm}
									disabled={!usdCashs?.length}
								/>
								<div className="relative">
									<input
										type="text"
										list="usd"
										placeholder={'USD касса | USD карта'}
										className={
											'border-[1px] border-[#DFE2E9"] p-2 rounded-md flex-1/2'
										}
										value={form.UsdCard}
										onChange={(v) => {
											setForm((prevValue) => ({
												...prevValue,
												UsdCard: v.target.value,
											}))
											console.log(v.target.value)
										}}
										disabled={!usdCashs?.length}
										autoComplete="off"
									/>
									<datalist id="usd">
										{usdCashs?.map((v, i) => (
											<option
												key={i}
												label={`${get(v, 'Name', '')} , ${get(v, 'Code', '')}`}
												value={get(v, 'Code', '')}
											/>
										))}
									</datalist>
								</div>
							</div>
							{!usdCashs?.length && (
								<p className={'text-red-600'}>
									Нет доступных USD касс или карт
								</p>
							)}
						</div>
						<div className={'flex flex-col gap-2'}>
							<div className={'flex flex-col md:flex-row gap-4'}>
								<MoneyInput
									placeholder="Наличные UZS"
									editableKey={'amountUzs'}
									form={form}
									setForm={setForm}
									disabled={!accountsDataUZS?.length}
								/>
								<div className="relative">
									<input
										type="text"
										list="uzs"
										placeholder={'UZS касса'}
										className={
											'border-[1px] border-[#DFE2E9"] p-2 rounded-md flex-1/2'
										}
										value={form.UzsCard}
										onChange={(v) => {
											setForm((prevValue) => ({
												...prevValue,
												UzsCard: v.target.value,
											}))
											console.log(v.target.value)
										}}
										disabled={!accountsDataUZS?.length}
										autoComplete="off"
									/>
									<datalist id="uzs">
										{accountsDataUZS?.map((v, i) => (
											<option
												key={i}
												label={`${get(v, 'Name', '')} , ${get(v, 'Code', '')}`}
												value={get(v, 'Code', '')}
											/>
										))}
									</datalist>
								</div>
							</div>
							{!accountsDataUZS?.length && (
								<span className="text-red-600 text-sm">
									{'UZS кассы не найдены'}
								</span>
							)}
						</div>
						<div className={'flex flex-col gap-2'}>
							<div className="flex flex-col md:flex-row gap-4">
								<MoneyInput
									placeholder="Карта Payme | Click"
									editableKey={'payme'}
									form={form}
									setForm={setForm}
									disabled={!uzsCardsData?.length}
								/>
								<div className="relative">
									<input
										type="text"
										list="productName"
										placeholder={'Номер карта'}
										className={
											'border-[1px] border-[#DFE2E9"] p-2 rounded-md flex-1/2'
										}
										value={form.numberCard}
										onChange={(v) =>
											setForm((prevValue) => ({
												...prevValue,
												numberCard: v.target.value,
											}))
										}
										disabled={!uzsCardsData?.length}
										autocomplete="off"
									/>
									<datalist id="productName">
										{uzsCardsData.map((v, i) => (
											<option
												key={i}
												label={`${get(v, 'Name', '')} , ${get(v, 'Code', '')}`}
												value={get(v, 'Code', '')}
											/>
										))}
									</datalist>
								</div>
							</div>
							{!uzsCardsData?.length && (
								<span className="text-red-600 text-sm">
									{'Карты не найдены'}
								</span>
							)}
						</div>
						<div className={'flex flex-col gap-2'}>
							<div className="flex flex-col md:flex-row gap-4">
								<MoneyInput
									placeholder="Терминал"
									editableKey={'terminal'}
									form={form}
									setForm={setForm}
									disabled={!get(getMe, 'U_TerminalAccount', '')}
								/>

								<input
									type="text"
									list="productName"
									placeholder={'Номер терминала'}
									className={
										'border-[1px] border-[#DFE2E9"] p-2 rounded-md flex-1/2'
									}
									value={get(getMe, 'U_TerminalAccount', '')}
									disabled
									autocomplete="off"
								/>
							</div>
							{!get(getMe, 'U_TerminalAccount', '') && (
								<p className="text-red-500">
									Номер терминала не указан в профиле
								</p>
							)}
						</div>
					</div>

					<div className={'my-7'}>
						<label
							className={
								'font-medium text-zinc-600 text-[14px] mb-1 flex flex-col gap-2 items-start'
							}
						>
							Общая сумма платежа
							<input
								value={numberWithSpaces(totalPayment) + ' USD'}
								className={
									'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-1/2'
								}
							/>
							{/* <input
								value={
									roundCurrency(
										(+form.amountUsd || 0) +
											(+form.amountUzs || 0) / (form.dollar || 1) +
											(+form.payme || 0) / (form.dollar || 1) +
											(+form.terminal || 0) / (form.dollar || 1),
									) + ' USD'
								}
								className={
									'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-1/2'
								}
							/> */}
							{/* TEST -5 */}
						</label>
					</div>

					<div className="flex gap-3">
						<Button
							btnStyle={{ backgroundColor: '#243AB5' }}
							onClick={() => {
								refundRef.current?.open()
								setForm({ ...initDate })
							}}
							hoverBtnStyle={{ backgroundColor: '#243AB5' }}
							className="my-4"
						>
							Сдачи
						</Button>
						<div className="flex flex-col gap-1">
							<Popconfirm
								title="Cashbackni yechish"
								description={`Cashback to'liq yechiladi (${numberWithSpaces(get(cashbackBalance, 'available', 0))} ${get(cashbackBalance, 'currency', '')}), qisman yechish mumkin emas. Davom etamizmi?`}
								okText="Ha"
								cancelText="Yo'q"
								onConfirm={handleRedeemCashback}
								disabled={!hasCashbackAvailable}
							>
								<Button
									btnStyle={{ backgroundColor: '#16A34A' }}
									hoverBtnStyle={{ backgroundColor: '#16A34A' }}
									isLoading={cashbackRedeeming || cashbackBalanceLoading}
									disabled={
										!cardCode || cashbackBalanceLoading || !hasCashbackAvailable
									}
									className="my-4"
								>
									Cashbackni ishlatish
								</Button>
							</Popconfirm>
							{cardCode && !cashbackBalanceLoading && (
								<span
									className={
										hasCashbackAvailable
											? 'text-green-600 text-sm'
											: 'text-red-600 text-sm'
									}
								>
									{hasCashbackAvailable
										? `Mavjud cashback: ${numberWithSpaces(get(cashbackBalance, 'available', 0))} ${get(cashbackBalance, 'currency', '')}`
										: CASHBACK_ERROR_MESSAGES.NoCashbackAvailable}
								</span>
							)}
						</div>
					</div>

					<div className="centerCard">
						<button
							className="btnN"
							onClick={() => {
								onClose()
								setForm({ ...initDate })
							}}
						>
							{loading ? <Spinner /> : 'Нет'}
						</button>
						<button
							className="btnY disabled:opacity-50 disabled:cursor-not-allowed"
							onClick={() => handleShowModal()}
							disabled={loading}
						>
							{loading ? <Spinner /> : 'Да'}
						</button>
					</div>
				</div>
				<RefundModal
					currencyRate={currencyRate}
					getRef={(r) => (refundRef.current = r)}
					onConfirm={(form) => handleRefund(form)}
					onClose={() => refundRef.current?.close()}
					isLoading={isRefund}
				/>
				<SuccessModal getRef={(r) => (successModalRef.current = r)} />
				<ErrorModal getRef={(r) => (errorRef.current = r)} />
				<ConfirmModal
					show={showModal}
					data={confirmationMessage}
					onConfirm={() => {
						onConfirm({
							DocDate: form.dateC,
							CurrencyRate: form.dollar,
							AmountUsd: form.amountUsd,
							AmountUzs: form.amountUzs,
							AmountPayme: form.payme,
							NumberCard: form.numberCard,
							Terminal: form.terminal,
							UsdCard: form.UsdCard,
							UzsCard: form.UzsCard,
						})
						setShowModal(false)
					}}
					onCancel={handleCancel}
				/>
			</PaymentModalStyle>
		</Modal>
	)
}

export default memo(PaymentModal)
